"use strict";
// https://www.figma.com/file/MFiT49pcOXpVZcxFsNg0JT/Swegon-Design-Suite?node-id=457%3A13
// S - Mobile
// M - Desktop HD (24 columns 1440px)
// L - Desktop Wide (24 columns 1960px)
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRID_PADDING = exports.ROW_GUTTER = exports.ROW_HEIGHT = exports.COLUMN_GUTTER_L = exports.COLUMN_GUTTER_M = exports.COLUMN_WIDTH = exports.ELEMENT_BASE = void 0;
// Element - Multiply element base with an integer.
exports.ELEMENT_BASE = "8px";
// Column
exports.COLUMN_WIDTH = "42px";
exports.COLUMN_GUTTER_M = "8px";
exports.COLUMN_GUTTER_L = "16px";
// Row
exports.ROW_HEIGHT = "48px";
exports.ROW_GUTTER = "8px";
// Padding
exports.GRID_PADDING = "24px";
//# sourceMappingURL=grid.js.map